import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

class LocationBanner {
    constructor(el) {
        if (!this.set(el)) return;
        
        if (
            document.readyState === 'complete' ||
            (document.readyState !== 'loading' && !document.documentElement.doScroll)
        ) {
            this.init();
        } else {
            document.addEventListener('DOMContentLoaded', this.init.bind(this));
        }
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.slider = this.root.querySelector('[data-locations-banner-slider]');
        this.pagination = this.root.querySelector(
            '[data-locations-banner-pagination]'
        );
        this.swiper = null;

        return true;
    }

    init() {
        this.initSlider();
        this.initWindow();
    }

    initSlider() {
        if (!this.slider) return;

        this.swiper = new Swiper(this.slider, {
            modules: [Pagination],
            slidesPerView: 'auto',
            spaceBetween: 24,
            pagination: {
                el: this.pagination,
                type: 'bullets',
                bulletClass: 'slider-pagination__bullet',
                bulletActiveClass: 'active',
            },
        });
    }

    initWindow() {
        window.addEventListener('resize', this.onResize.bind(this));
        this.onResize();
    }

    onResize() {
        const { innerWidth } = window;

        if (innerWidth > 992) {
            if (this.swiper) {
                this.swiper.destroy();
                this.swiper = null;
            }
        } else {
            if (!this.swiper) this.initSlider();
        }
    }
}

const initLocationsBanners = () => {
    const sections = document.querySelectorAll('[data-locations-banner]');
    if (sections) sections.forEach(item => new LocationBanner(item));
};

initLocationsBanners();
